import { Text } from "@/components/Theme/Text";
import { useColorScheme } from "@/hooks/useColorScheme";
import { useTranslation } from "@/hooks/useTranslation";
import isEqual from 'lodash/isEqual';
import { memo, useMemo } from "react";
import Markdown from 'react-native-markdown-display';
import { markdownIt } from "./atoms/markdownIt";
import { markdownItNoAutoLink } from "./atoms/markdownItNoAutoLink";
import { buildRules } from "./rules";
import { useMarkdownStyles } from "./styles";

export const MarkdownExtended = memo(({ text, rules, noAutoLinking = false, translate = false, styles }) => {

  const defaultStyles = useMarkdownStyles();
  const colorScheme = useColorScheme();
  const { t } = useTranslation();

  const customRules = useMemo(() => {
    return buildRules(colorScheme);
  }, [colorScheme]);

  if (!text) 
    return <Text>{text}</Text>;

  if (translate) {
    text = t(text);
  }

  return (
    <Markdown
      markdownit={noAutoLinking ? markdownItNoAutoLink : markdownIt}
      rules={{ ...customRules, ...rules }}
      style={{ ...defaultStyles, ...styles }}
    >
      {text}
    </Markdown>
  );

}, isEqual);